import { defineMessages } from "react-intl";

const REQUEST_VERIFICATION_DATA_FORM = "request-verification-data-form";

const requestVerificationDataFormMessages = defineMessages({
  reset: {
    id: `${REQUEST_VERIFICATION_DATA_FORM}.reset`,
    defaultMessage: "Reset",
    description:
      "Title for button to click to request verification data to reset their password"
  },
  unableToSubmitRequest: {
    id: `${REQUEST_VERIFICATION_DATA_FORM}.unable-to-submit-request`,
    defaultMessage:
      "Unable to submit request to reset your password. Please try again later."
  },
  username: {
    id: `${REQUEST_VERIFICATION_DATA_FORM}.username`,
    defaultMessage: "Email address or username",
    description: "Text input label for email or username."
  },
  requireUsername: {
    id: `${REQUEST_VERIFICATION_DATA_FORM}.required-username`,
    defaultMessage: "Please provide an email address or username.",
    description:
      "Text input validation error for when an email or username was not provided."
  },
  resetPasswordInstructions: {
    id: `${REQUEST_VERIFICATION_DATA_FORM}.reset-password-instructions`,
    defaultMessage:
      "If you sign into your account with a username, enter that username. If you sign into your account with an email address, enter that email address."
  }
});

export default requestVerificationDataFormMessages;
